import { render, staticRenderFns } from "./ForgotAdress.vue?vue&type=template&id=24870637&scoped=true&"
import script from "./ForgotAdress.vue?vue&type=script&lang=js&"
export * from "./ForgotAdress.vue?vue&type=script&lang=js&"
import style0 from "./ForgotAdress.vue?vue&type=style&index=0&id=24870637&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24870637",
  null
  
)

export default component.exports